import styled from 'styled-components';

import {
    CONTENT_BASE,
    SURFACE_BASE,
    TERTIARY_BACKGROUND,
    TERTIARY_BORDER
} from '@amzn/ring-common-style-library/lib/colors';

import {
    FOOTNOTE_XSMALL_MEDIUM
} from '@amzn/ring-common-style-library/lib/typography';

const MoreMenu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    border-radius: 8px;
    border: 1px solid ${TERTIARY_BORDER};
    background: ${SURFACE_BASE};

    box-shadow: 0px 8px 12px 0px var(--shadow-base, rgba(0, 0, 0, 0.15));
    z-index: 3; // overlay header menu

    position: absolute;
    right: 16px;
    top: 60px;
`;


const MenuItem = styled.div`
    display: flex;
    align-items: center;
    width: 124px;

    ${FOOTNOTE_XSMALL_MEDIUM}
    color: ${CONTENT_BASE};
    border-radius: 8px;
    cursor: pointer;

    padding: 12px 8px;
    gap: 8px;

    &:hover {
        background-color: ${TERTIARY_BACKGROUND};
    }
`;

const MenuIcon = styled.div`
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
`;

const CloseButton = styled.div`
    flex: 0 0 auto;
    width: 24px;
    height: 24px;

    cursor: pointer;
`;

export default {
    MoreMenu,
    MenuItem,
    MenuIcon,
    CloseButton,
}